import { useQuery } from "react-query";
import { getStates } from "../../../actions/Utilities/Common";

export const useStates = () => {
  return useQuery("GetStates", getStates, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
